import React from 'react'

const Image = ({imgsrc}) => {
  return (
    <img  src={imgsrc} alt='imag'/>
  )
}

export default Image